import { RootState } from 'store/root-reducer';

export const dashboardSelector = (state: RootState) => state.dashboard;
export const creditOverviewSelector = (state: RootState) => state.dashboard.creditOverview;
